import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

export const broadcastsSpaceDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const broadcastsSortOptions: OptionsDictionary = {
    'name': SortOptions.name,
};
